module.exports =
  require('./bookingsEditorScript').createBookingsEditorScriptWithEcom();
